import { PresentationChartLineIcon, TableCellsIcon } from '@heroicons/react/24/solid';
import { useTranslations } from '../hooks/useTranslations';
import { useLanguage } from '../contexts/LanguageContext';

// Конфигурация секций видеоуроков
export const useVideoSections = () => {
  const { t } = useTranslations();
  const { currentLanguage } = useLanguage();
  
  return [
    {
      id: 'trading',
      title: t('videoSections.trading.title'),
      lessons: 14,
      Icon: PresentationChartLineIcon,
      path: '/education/video/trading',
      allowedCourses: ['GOLD', 'SILVER', 'PLATINUM'], 
      description: t('videoSections.trading.description'),
    },
    {
      id: 'forex',
      title: t('videoSections.forex.title'),
      lessons: 30,
      Icon: PresentationChartLineIcon,
      path: '/education/video/forex',
      allowedCourses: ['GOLD', 'SILVER', 'PLATINUM'], // Доступно для всех платных курсов
      description: t('videoSections.forex.description'),
    },
    {
      id: 'excel',
      title: t('videoSections.excel.title'),
      lessons: "62 + 52",
      Icon: TableCellsIcon,
      path: '/education/video/excel',
      allowedCourses: ['GOLD', 'SILVER', 'PLATINUM'], 
      description: t('videoSections.excel.description'),
    },
    {
      id: 'excel-advanced',
      title: t('videoSections.excelAdvanced.title'),
      lessons: 35,
      Icon: TableCellsIcon,
      path: '/education/video/excel-advanced',
      allowedCourses: ['PLATINUM'], 
      description: t('videoSections.excelAdvanced.description'),
    },
    {
      id: 'trading-plan',
      title: t('videoSections.tradingPlan.title'),
      lessons: 5,   
      Icon: PresentationChartLineIcon,
      path: '/education/video/trading-plan',
      allowedCourses: ['PLATINUM'], 
      description: t('videoSections.tradingPlan.description'),
    },
    {
      id: 'technical-analysis',
      title: t('videoSections.technicalAnalysis.title'),
      lessons: 6,
      Icon: PresentationChartLineIcon,
      path: '/education/video/technical-analysis',
      allowedCourses: ['GOLD', 'PLATINUM'], 
      description: t('videoSections.technicalAnalysis.description'),
    },
    {
      id: 'macroeconomics',
      title: t('videoSections.macroeconomics.title'),
      lessons: 1,
      Icon: PresentationChartLineIcon,
      path: '/education/video/macroeconomics',
      allowedCourses: ['PLATINUM'], 
      description: t('videoSections.macroeconomics.description'),
    }
  ];
};

// Функция для получения секций без перевода (для использования вне компонентов)
export const getVideoSections = () => {
  return [
    {
      id: 'trading',
      title: 'Курс основ финансового рынка',
      lessons: 14,
      Icon: PresentationChartLineIcon,
      path: '/education/video/trading',
      allowedCourses: ['GOLD', 'SILVER', 'PLATINUM'], 
      description: 'Продвинутые техники трейдинга',
    },
    {
      id: 'forex',
      title: 'Форекс',
      lessons: 30,
      Icon: PresentationChartLineIcon,
      path: '/education/video/forex',
      allowedCourses: ['GOLD', 'SILVER', 'PLATINUM'],
      description: 'Базовые принципы торговли на валютном рынке',
    },
    {
      id: 'excel',
      title: 'Excel - beginner + intermediate',
      lessons: "62 + 52",
      Icon: TableCellsIcon,
      path: '/education/video/excel',
      allowedCourses: ['GOLD', 'SILVER', 'PLATINUM'], 
      description: 'Работа с Excel для трейдинга и анализа',
    },
    {
      id: 'excel-advanced',
      title: 'Excel - advanced + VBA',
      lessons: 35,
      Icon: TableCellsIcon,
      path: '/education/video/excel-advanced',
      allowedCourses: ['PLATINUM'], 
      description: 'Продвинутые функции Excel и VBA',
    },
    {
      id: 'trading-plan',
      title: 'TRADING PLAN & STRATEGIES',
      lessons: 5,   
      Icon: PresentationChartLineIcon,
      path: '/education/video/trading-plan',
      allowedCourses: ['PLATINUM'], 
      description: 'Создание торгового плана и стратегий',
    },
    {
      id: 'technical-analysis',
      title: 'Technical Analysis Indicators',
      lessons: 6,
      Icon: PresentationChartLineIcon,
      path: '/education/video/technical-analysis',
      allowedCourses: ['GOLD', 'PLATINUM'], 
      description: 'Технический анализ и индикаторы',
    },
    {
      id: 'macroeconomics',
      title: 'Макроэкономические основы',
      lessons: 1,
      Icon: PresentationChartLineIcon,
      path: '/education/video/macroeconomics',
      allowedCourses: ['PLATINUM'], 
      description: 'Полный анализ',
    }
  ];
};

// Функция для проверки доступа пользователя к секции
export const hasAccessToSection = (section, userData) => {
  if (!userData || !userData.course) return false;
  
  const userCourse = userData.course.toUpperCase();
  return section.allowedCourses.includes(userCourse);
};

// Функция для получения доступных секций для пользователя
export const getAccessibleSections = (userData) => {
  const videoSections = getVideoSections();
  return videoSections.filter(section => hasAccessToSection(section, userData));
};

// Функция для получения всех курсов, которые имеют доступ к определенной секции
export const getCoursesWithAccess = (sectionId) => {
  const videoSections = getVideoSections();
  const section = videoSections.find(s => s.id === sectionId);
  return section ? section.allowedCourses : [];
}; 